<template>
  <div class="footer-wrapper">
    <!-- 顶部区域：左侧 Logo + 公司名称 -->
    <div class="footer-top">
      <div class="footer-top-left">
        <img class="footer-logo" src="@/assets/img/keji1-logo.png" alt="公司LOGO" />
        <span class="company-name">北京三块出行科技有限公司</span>
      </div>
    </div>

    <!-- 第一条横线 -->
    <hr class="footer-divider" />

    <!-- 中间内容区域，分为三列：左侧导航链接、中间联系方式、右侧二维码 -->
    <div class="footer-content">
      <!-- 左侧导航链接 -->
      <div class="footer-column footer-links">
        <!-- 使用 router-link 来跳转页面 -->
        <router-link to="/home">网站首页</router-link>
        <router-link to="/product">产品介绍</router-link>
        <router-link to="/join">招商加盟</router-link>
        <router-link to="/aboutus">关于我们</router-link>
      </div>

      <!-- 中间联系方式 -->
      <div class="footer-column footer-contact">
        <p>联系我们</p>
        <p>联系电话：+400 6727 617</p>
        <p>电子邮箱：info@cducktech.com</p>
        <p>公司地址：杭州市钱塘区钱塘向上创业园4号楼16层</p>
      </div>

      <!-- 右侧二维码 -->
      <div class="footer-column footer-qr">
        <div class="qr-block">
          <img src="@/assets/img/QRcode-1.jpg" alt="冲鸭e行小程序二维码" />
          <p style="font-size: 1.05rem">冲鸭e行小程序二维码</p>
        </div>
<!--        <div class="qr-block">-->
<!--          <p>微信公众号二维码</p>-->
<!--          <img src="@/assets/img/1.png" alt="微信公众号二维码" />-->
<!--        </div>-->
      </div>
    </div>

    <!-- 第二条横线 -->
    <hr class="footer-divider" />

    <!-- 底部版权与备案 -->
    <div class="footer-bottom">
      <p>
        Copyright &copy; 2025 北京三块出行科技有限公司 All rights reserved &nbsp;&nbsp;&nbsp;&nbsp; 备案号：京ICP备2025112993号-2
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
/* 整个footer容器的背景、字体等基础样式 */
.footer-wrapper {
  width: 100%;
  color: #fff;
  background-color: #55d5dc;
  padding: 20px 0;
}

/* 顶部区域：logo + 公司名称 */
.footer-top {
  display: flex;
  align-items: center;
  padding: 0 70px;
  margin-bottom: -20px;
}
.footer-top-left {
  display: flex;
  align-items: center;
}
.footer-logo {
  width: 60px;
  height: auto;
  margin-right: 10px;
}
.company-name {
  font-size: 20px;
  font-weight: 600;
}

/* 分割线 */
.footer-divider {
  width: 90%;
  margin: 20px auto;
  border: none;
  border-top: 2px solid #ffffff;
  opacity: 0.3;
}

/* 中间三列布局 */
.footer-content {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 90%;
}
.footer-column {
  flex: 1;
  margin: 0 10px;
}
/* 左侧导航链接 */
.footer-links a {
  display: block;
  color: #fff;
  text-decoration: none;
  margin-bottom: 10px;
  font-size: 15px;
}
.footer-links a:hover {
  text-decoration: underline;
}

/* 中间联系方式 */
.footer-contact p {
  margin-bottom: 10px;
  font-size: 15px;
}

/* 右侧二维码 */
.footer-qr .qr-block {
  margin-bottom: 0;
  float: right;
}
.footer-qr img {
  width: 100px;
  height: 100px;
  margin-top: 5px;
  padding: 2px;
  border: #fff solid 2px;
  border-radius: 5px;
}

/* 底部版权与备案信息 */
.footer-bottom {
  text-align: center;
  margin-top: 10px;
}
.footer-bottom p {
  margin: 5px 0;
  font-size: 14px;
}

/* 自适应屏幕，小屏时可考虑改为列布局 */
@media screen and (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
  }
  .company-name {
    font-size: 15px;
  }
  .footer-logo {
    width: 50px;
  }
  .footer-column {
    margin: 10px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue